import React from 'react';

// Reusable Yes/No confirmation modal for destructive actions (delete
// customer, deactivate a service, etc). Controlled: render it unconditionally
// and pass `open`, so callers keep their own confirm-target state.
export default function ConfirmDialog({ open, title, message, confirmLabel = 'Yes', cancelLabel = 'No', danger = true, onConfirm, onCancel }) {
  if (!open) return null;

  return (
    <div className="admin-modal-backdrop" onClick={onCancel}>
      <div className="admin-modal-card" onClick={(e) => e.stopPropagation()}>
        {title && <h2>{title}</h2>}
        <p>{message}</p>
        <div className="admin-form-actions">
          <button className="admin-btn admin-btn-secondary" onClick={onCancel}>{cancelLabel}</button>
          <button className={`admin-btn ${danger ? 'admin-btn-danger' : 'admin-btn-primary'}`} onClick={onConfirm}>
            {confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
}
